import { render, staticRenderFns } from "./RolesSelectField.vue?vue&type=template&id=40d3c318&scoped=true&"
import script from "./RolesSelectField.vue?vue&type=script&lang=js&"
export * from "./RolesSelectField.vue?vue&type=script&lang=js&"
import style0 from "./RolesSelectField.vue?vue&type=style&index=0&id=40d3c318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d3c318",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
